import { Anchor } from "@mantine/core";
import type { ReactNode } from "react";

interface LinkProps {
  children?: ReactNode;
  href?: string;
  title?: string;
}

/**
 * Link renders a link as a Mantine `Anchor`. Internal targets (starting with `/`
 * or `#`) render plain; external `http(s)` targets open in a new tab with
 * `rel="noopener noreferrer"`.
 */
export const Link = ({ children, href = "", title }: LinkProps) => {
  const isExternal = /^https?:\/\//.test(href);

  if (isExternal) {
    return (
      <Anchor href={href} rel="noopener noreferrer" target="_blank" title={title}>
        {children}
      </Anchor>
    );
  }

  return (
    <Anchor href={href} title={title}>
      {children}
    </Anchor>
  );
};
